var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGift28(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.003 3.5c1.874 3.748-1.308 4.406-4.705 4.5H23c.464 0 .697 0 .892.026a3 3 0 0 1 2.582 2.582c.026.195.026.428.026.892v.5a3 3 0 0 1-3 3h-8V8.011l-.484-.004c-.35-.004-.69-.007-1.013-.007 0-4 5.5-9.5 8-4.5ZM12.5 8.011l.487-.004C13.337 8.003 13.677 8 14 8c0-4-5.5-9.5-8-4.5C4.126 7.248 7.309 7.906 10.705 8H5c-.464 0-.697 0-.892.026a3 3 0 0 0-2.582 2.582c-.026.195-.026.428-.026.892v.5a3 3 0 0 0 3 3h8V8.011ZM4.5 18v3.2c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.78 26 7.62 26 9.3 26h3.2v-8h-8Zm11 0v8h3.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311c.327-.642.327-1.482.327-3.162V18h-8Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift28);
export default __webpack_public_path__ + "static/media/gift_28.2302ac06.svg";
export { ForwardRef as ReactComponent };